import React, { useState } from "react";
import { Await, NavLink, useNavigate } from "react-router-dom";
import { FaEyeSlash, FaEye, FaLessThanEqual } from "react-icons/fa";
import { AuthApis } from "../../../apis/authApis";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../../reducer/loginSlice";
import { Oval } from "react-loader-spinner";
import { DashboardApi } from "../../../apis/DashboardApi";
import { AxiosResponse } from "axios";
import { shared } from "../../../reducer/SharedSlice";

function Login() {


  // React.useEffect(() => {
  //   window.location.reload()
  // }, []);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const userLoginData = useSelector((state: any) => state.data.login.value);

  const [userData, setUserdata] = useState({
    'email': "",
    'password': "",
  });

  const [loader, setLoader] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setUserdata({ ...userData, [name]: value });
  };


  // React.useEffect(() => {
  //   userLoginData?.token ?
  //     navigate("/dashboard")
  //     :
  //     navigate("/sign-in");
  // }, []);

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    dispatch(login({
      email: "",
      name: "",
      password: "",
      token: "",
      data: []
    }));

    const formData = new FormData();
    formData.append('email', userData?.email);
    formData.append('password', userData?.password);

    try {
      AuthApis.login(formData).then(
        (response: AxiosResponse<any>) => {
          if (response?.data) {
            dispatch(login({ email: userData?.email, token: response.data.data.token, data: response.data.data }))
            DashboardApi.getMediaUsage().then(
              (response2: AxiosResponse<any>) => {
                if (response2?.data) {
                  dispatch(shared({ data: response2?.data?.data }))
                  setLoader(false);
                  if (response?.data?.data?.user_data?.role == 'superadmin') {
                    navigate('/admin');
                  } else {
                    navigate('/dashboard');
                  }
                  setTimeout(() => window.location.reload(), 200);
                  // window.location.reload();
                } else {
                  setLoader(false);
                  toast.error('Try Again');
                  setTimeout(() => window.location.reload(), 200);
                  // window.location.reload();
                }
              }
            )
          } else {
            setLoader(false);
            toast.error('Invalid Credentials');
          }
        }
      )
    } catch (error: any) {
      console.log(error.response.data);
      setLoader(false);
      toast.error('Invalid Credentials');
    } finally {
      // setLoader(false);
    }
  };



  return (
    <>
      {/* <!-- Start block --> */}

      <section className="bg-[#F8F8F8] h-screen body-font font-poppins">

        <div className="bg-gray-100 py-6 pl-8 cursor-pointer">
          <NavLink to={'/'} >
            <img src="images/log.svg" />
          </NavLink>
        </div>

        <div className="flex flex-col md:flex-row h-[calc(100vh-100px)]">
          {/* Left Section - Images - Takes up 2/3 of the space */}
          <div className="bg-gray-100 w-full md:w-2/4 hidden md:flex flex-col items-center justify-center p-4">
            <div className="grid grid-cols-2 gap-6 w-full max-w-2xl">
              <img
                src="images/img4.png"
                alt="Family 1"
                className="rounded-lg object-cover w-full h-60"
              />
              <img
                src="images/img5.png"
                alt="Family 2"
                className="rounded-lg object-cover w-full h-60"
              />
              <img
                src="images/img11.png"
                alt="Family 3"
                className="rounded-lg object-cover w-full h-60"
              />
              <img
                src="images/img2.png"
                alt="Family 4"
                className="rounded-lg object-cover w-full h-60"
              />
            </div>
          </div>

          {/* Right Section - Form - Takes up 1/3 of the space */}
          <div className="w-full md:w-2/4 flex flex-col items-center justify-center p-6">
            <div className="max-w-sm w-full">
              <h1 className="text-2xl font-bold mb-6 text-center">Login to your Account</h1>
              <form className="space-y-4" onSubmit={handleSubmit}>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium mb-1">
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"
                    onChange={handleChange}
                    id="email"
                    placeholder="Enter your email"
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                </div>
                <div>
                  <label htmlFor="password" className="block text-sm font-medium mb-1">
                    Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    onChange={handleChange}
                    placeholder="Enter your password"
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                </div>
                <div className="flex justify-between items-center text-sm">
                  <a href="/forgot-password" className="text-orange-500 hover:underline">
                    Forgot Password?
                  </a>

                  <div className="flex gap-2">
                    <span className=" text-[10px]">Don't have an account?</span>
                    <a href="/sign-up" className="text-orange-500 hover:underline">
                      Sign up
                    </a>
                  </div>

                </div>
                <button
                  type="submit"
                  disabled={loader}
                  className="w-full bg-orange-500 text-white py-2 px-4 rounded-md hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500"
                >
                  {loader ? "Loading..." : 'Sign in'}
                </button>
              </form>
              <div className="mt-6">
                <p className="text-center text-sm text-gray-500">
                  &copy; 2025 bETERNAL. All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />

      {/* <!-- End block --> */}
    </>
  );
}

export default Login;